import config from '../../config';

export const sanitizeFavoriteName = name => name.replace(/[^a-z0-9]+/gi, '+');

export const getLegacyChartsUrl = ([lat, lon]) => `/map/#5/${lat}/${lon}`;

export const convertLegacyURL = (favorite) => {
  if (!favorite.hasOwnProperty('point')) {
    return favorite.legacyUrl || '#';
  }
  if ('name' in favorite) {
    return `/forecast/marine-weather/favorites/${sanitizeFavoriteName(favorite.name)}/@${favorite.point[1]},${favorite.point[0]}`;
  }
  return `/forecast/marine-weather/@${favorite.point[1]},${favorite.point[0]}`;
};

export const productsUrls = {
  marine_weather: (favorite) => {
  	if ('name' in favorite) {
    return `/forecast/marine-weather/favorites/${sanitizeFavoriteName(favorite.name)}/@${favorite.point[1]},${favorite.point[0]}`;
  	}
    return `/forecast/marine-weather/@${favorite.point[1]},${favorite.point[0]}`;
  },
  pointOfInterest: poi => `${config.bwHost}/forecast/marine-weather/spot/${poi.title.replace(/[^a-z0-9]+/gi, '+')}/@${poi.location.coordinates[1]},${poi.location.coordinates[0]}`,
  nearshore_text: convertLegacyURL,
  weather_text: convertLegacyURL,
  sea_surface_height: convertLegacyURL,
  detailed_swell_surf: convertLegacyURL,
  offshore_text: convertLegacyURL,
  nearshore_wave: convertLegacyURL,
  wave_height: convertLegacyURL,
  forecast: convertLegacyURL,
};

export const getProductUrl = (favorite) => {
  if (favorite.product in productsUrls) {
	  return productsUrls[favorite.product](favorite);
  }
	  return favorite.legacyUrl || '#';
};



// WEBPACK FOOTER //
// ./src/utils/urls/productUrls.js